import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import { lazy } from "react"

const SessionExpired = lazy(() =>
  import("#pages/login/session-expired.tsx").then((m) => ({ default: m.SessionExpired })),
)

export const Route = createFileRoute("/_auth/session-expired")({
  staticData: { title: "Session Expired" },
  beforeLoad: ({ context }) => {
    if (context.userInfo.state === "LoggedIn") {
      throw redirect({ to: "/" })
    }
  },
  component: SessionExpiredRoute,
})

function SessionExpiredRoute() {
  const navigate = useNavigate()
  return <SessionExpired onSendLink={() => void navigate({ to: "/sign-in" })} />
}
